import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debounceTime } from 'rxjs/operators';
import { DialogBase, RentalInfo} from 't4core';
import { RentalDialog } from '../../../../t4common/';


@Component({
    selector: 'findBookingDialog',
    templateUrl: 'findBookingDialog.html',
})
export class FindBookingDialog extends DialogBase {
    public bookings: RentalInfo[] = [];

    public txtKeywords: FormControl = new FormControl();

    constructor(
        public dialogRef: MatDialogRef<FindBookingDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super("FindBookingDialog");

        this.txtKeywords.valueChanges.pipe(debounceTime(1000))
            .subscribe(() => {
                this.findBookings();
            });
    }

    private async findBookings() {
        var token = this.beginLoad('Turbo.OneWayAdmin.FindBookingDialog.msgSearching', 'Looking for bookings', null);
        this.Api.get<RentalInfo[]>('/Rental/FindOneWayBookings', { keywords: this.txtKeywords.value }).then(x => {
            this.bookings = x;


            this.endLoad(token);
        });
    }

    public showBooking(id: number) {
        RentalDialog.openBooking(this.Dialog, id);
    }
}
